export enum FeedbackThumb {
  UP = 'up',
  DOWN = 'down',
}
